import React from 'react'
import { observer, makeAutoObservable } from '@/hooks/storeHooks'
import st from './index.scss'

class ToastStore {
    // 弹框列表
    toast = null
    time_id = null

    constructor() {
        makeAutoObservable(this)
    }

    setToast(arg, { during = 3000 } = {}) {
        this.time_id && clearTimeout(this.time_id) && (this.time_id = null)
        this.toast = arg
        this.time_id = setTimeout(() => this.toast = null, during)
    }
}

const store = new ToastStore()

// 弹框方法
export function toast(arg, options) {
    store.setToast(arg, options)
}

// 移除弹框
export function remove() {
    store.setToast(null)
}

// 弹框容器
export default observer(function CenterToast() {

    if (!store.toast) return null

    return <div className={st['box']} onClick={() => store.setToast(null)}>{store.toast}</div>
})
